import React, { useState } from 'react';
import PageShell, { SectionTitle } from './PageShell';
import { Play, Clock, Tag, ShieldAlert, Sparkles, ExternalLink, X, Maximize2 } from 'lucide-react';

// 6 vidéos officielles Sécurité routière (campagnes nationales)
const CAMPAGNES = [
  {
    id: 'j68E5NCF1_A',
    cat: 'Partage de la route',
    title: 'Le partage de la route, un défi au quotidien',
    desc: 'Épisode 18 de la série officielle Sécurité routière sur la cohabitation entre tous les usagers.',
    duration: 'Officiel',
    source: 'Sécurité routière',
  },
  {
    id: 'sajYoj_REk0',
    cat: 'Vitesse',
    title: 'Messieurs, si vous voulez l\u2019égalité, levez le pied',
    desc: "Campagne nationale sur la vitesse et son rôle dans les drames routiers. Une prise de conscience qui dérange.",
    duration: 'Officiel',
    source: 'Sécurité routière',
  },
  {
    id: '4JRGCo2StkA',
    cat: 'Téléphone',
    title: 'Zombies Phone — format court',
    desc: 'Le téléphone au volant transforme les conducteurs en zombies. Spot 30 secondes choc.',
    duration: '0:30',
    source: 'Sécurité routière',
  },
  {
    id: 'e5cXh_-p1DM',
    cat: 'Téléphone',
    title: 'Quand vous regardez votre téléphone, qui regarde la route ?',
    desc: 'Lire un message au volant = 5 secondes les yeux hors de la route. À 90 km/h, c\u2019est 125 mètres en aveugle.',
    duration: 'Officiel',
    source: 'Sécurité routière',
  },
  {
    id: 'X9ua3a9vBy0',
    cat: 'Angles morts',
    title: 'Méfiez-vous des angles morts — ils portent très bien leur nom',
    desc: "Campagne nationale sur les zones que les rétroviseurs ne couvrent jamais et qui tuent piétons et cyclistes.",
    duration: 'Officiel',
    source: 'Sécurité routière',
  },
  {
    id: 'wgLd0Uj8qLo',
    cat: 'Portière',
    title: '« Portière gauche, main droite ; portière droite, main gauche »',
    desc: 'Le « réflexe néerlandais » : ouvrir sa portière avec la main opposée pour voir le cycliste qui arrive. Le geste qui sauve.',
    duration: 'Officiel',
    source: 'Sécurité routière',
  },
];

// Tutos pédagogiques court-format (placeholders pour future production interne)
const TUTOS = [
  { id: 't1', cat: 'Départ / arrêt', title: 'Démarrer sur une côte sans reculer', desc: 'Frein à main, point de patinage, coordination embrayage / accélérateur.', duration: '4:12', thumb: 'https://images.unsplash.com/photo-1502161254066-6c74afbf07aa?w=900&q=80' },
  { id: 't2', cat: 'Manœuvre', title: 'Le créneau parfait en 5 étapes', desc: 'Aligner, reculer, braquer, contre-braquer, ajuster. La méthode des moniteurs ECSR.', duration: '6:48', thumb: 'https://images.unsplash.com/photo-1568605117036-5fe5e7bab0b7?w=900&q=80' },
  { id: 't3', cat: 'Manœuvre', title: 'Le demi-tour en 3 temps maximum', desc: 'Voie étroite, sans monter sur le trottoir, sans gêner la circulation.', duration: '5:22', thumb: 'https://images.unsplash.com/photo-1553782097-130fef5d3e27?w=900&q=80' },
  { id: 't4', cat: 'Vérifications', title: 'Les 12 vérifications avant le départ', desc: 'Pneus, niveaux, freins, éclairage : la check-list pré-trajet officielle.', duration: '7:55', thumb: 'https://images.pexels.com/photos/3806249/pexels-photo-3806249.jpeg?w=900' },
  { id: 't5', cat: 'Circulation', title: 'Aborder un rond-point comme un pro', desc: 'Clignotants, voies, priorité, sortie : tout ce que l\u2019examinateur regarde.', duration: '5:10', thumb: 'https://images.unsplash.com/photo-1473042904451-00171c69419d?w=900&q=80' },
  { id: 't6', cat: 'Circulation', title: 'Le dépassement en sécurité', desc: "Préparation, exécution, reprise de file. Distances et règle des 50 km/h d\u2019écart.", duration: '6:30', thumb: 'https://images.unsplash.com/photo-1492144534655-ae79c964c9d7?w=900&q=80' },
  { id: 't7', cat: 'Examen', title: 'Le jour J : la routine du candidat sereine', desc: "Que dire, comment se positionner, comment gérer le stress de l\u2019examinateur.", duration: '8:15', thumb: 'https://images.unsplash.com/photo-1630406144797-821be1f35d75?w=900&q=80' },
  { id: 't8', cat: 'Éco-conduite', title: 'Conduire éco : -20 % de consommation', desc: 'Anticipation, rapports, vitesse stable. Les 5 gestes qui changent tout.', duration: '5:48', thumb: 'https://images.unsplash.com/photo-1518614368389-9f9e0a05c7e0?w=900&q=80' },
  { id: 't9', cat: 'Conditions difficiles', title: 'Rouler sous la pluie en sécurité', desc: 'Aquaplanage, distances de freinage doublées, visibilité. Adapter sa conduite.', duration: '6:05', thumb: 'https://images.unsplash.com/photo-1438449805896-28a666819a20?w=900&q=80' },
];

const CATS = ['Toutes', 'Partage de la route', 'Vitesse', 'Téléphone', 'Angles morts', 'Portière', 'Départ / arrêt', 'Manœuvre', 'Vérifications', 'Circulation', 'Examen', 'Éco-conduite', 'Conditions difficiles'];

function thumb(videoId) {
  return `https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`;
}

function VideoCard({ video, onPlay, official = false }) {
  return (
    <button
      onClick={() => onPlay(video)}
      data-testid={`video-card-${video.id}`}
      className="group text-left rounded-2xl overflow-hidden border border-white/10 bg-[#0d0d0e] hover:border-red-700/40 transition card-lift cursor-pointer w-full"
    >
      <div className="relative aspect-[16/10] overflow-hidden">
        <img
          src={video.thumb || thumb(video.id)}
          alt={video.title}
          className="absolute inset-0 w-full h-full object-cover img-zoom"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/30 to-transparent" />
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="w-16 h-16 rounded-full bg-red-600 flex items-center justify-center shadow-xl group-hover:scale-110 transition">
            <Play className="text-white ml-1" size={26} fill="currentColor" />
          </div>
        </div>
        <div className="absolute bottom-3 right-3 px-2 py-0.5 rounded-md bg-black/70 backdrop-blur text-white text-[11px] font-mono-spec inline-flex items-center gap-1">
          <Clock size={10} /> {video.duration}
        </div>
        <div className="absolute top-3 left-3 px-2 py-0.5 rounded-md bg-red-600 text-white text-[10px] font-bold tracking-wider inline-flex items-center gap-1">
          <Tag size={10} /> {video.cat}
        </div>
        {official && (
          <div className="absolute top-3 right-3 px-2 py-0.5 rounded-md bg-black/70 backdrop-blur border border-white/20 text-white text-[10px] font-bold tracking-wider inline-flex items-center gap-1">
            <ShieldAlert size={10} className="text-red-400" /> OFFICIEL
          </div>
        )}
      </div>
      <div className="p-4 sm:p-5">
        <h3 className="font-serif-editorial text-white text-[16px] sm:text-[19px] leading-tight">{video.title}</h3>
        <p className="text-white/55 text-[12px] sm:text-[13px] mt-1.5 sm:mt-2 line-clamp-3">{video.desc}</p>
        {video.source && (
          <div className="mt-2 sm:mt-3 text-[10.5px] sm:text-[11px] text-white/45 font-mono-spec uppercase tracking-wider">
            Source : {video.source}
          </div>
        )}
      </div>
    </button>
  );
}

function PlayerModal({ video, onClose }) {
  if (!video) return null;
  return (
    <div
      onClick={onClose}
      data-testid="video-modal"
      className="fixed inset-0 z-[200] bg-black/90 backdrop-blur-sm flex items-center justify-center p-4"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-full max-w-5xl bg-[#0d0d0e] rounded-2xl overflow-hidden border border-white/10 shadow-2xl"
      >
        <div className="flex items-center justify-between px-5 py-3 border-b border-white/10">
          <div className="min-w-0 pr-4">
            <div className="text-[10.5px] uppercase tracking-[0.22em] text-red-400 font-bold font-mono-spec truncate">
              {video.cat}{video.source ? ` · ${video.source}` : ''}
            </div>
            <h3 className="font-serif-editorial text-white text-[18px] leading-tight mt-1 truncate">{video.title}</h3>
          </div>
          <div className="flex items-center gap-2 shrink-0">
            <a
              href={`https://www.youtube.com/watch?v=${video.id}&fullscreen=1`}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="video-modal-fullscreen"
              title="Ouvrir en plein écran YouTube (projection classe)"
              className="w-9 h-9 rounded-full border border-white/15 bg-white/5 hover:bg-white/15 text-white flex items-center justify-center transition"
            >
              <Maximize2 size={14} />
            </a>
            <button
              onClick={onClose}
              data-testid="video-modal-close"
              className="w-9 h-9 rounded-full border border-white/15 bg-white/5 hover:bg-white/15 text-white flex items-center justify-center transition"
              aria-label="Fermer"
            >
              <X size={16} />
            </button>
          </div>
        </div>
        <div className="aspect-video bg-black">
          <iframe
            src={`https://www.youtube.com/embed/${video.id}?autoplay=1&rel=0&modestbranding=1`}
            title={video.title}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; fullscreen"
            allowFullScreen
            className="w-full h-full"
          />
        </div>
        <div className="px-5 py-4 border-t border-white/10 flex items-center justify-between gap-3 flex-wrap">
          <p className="text-white/55 text-[12px] max-w-[60%]">
            La vidéo ne s&apos;affiche pas ? Certaines campagnes officielles bloquent la lecture intégrée — clique sur le bouton ci-dessous pour la voir sur YouTube.
          </p>
          <a
            href={`https://www.youtube.com/watch?v=${video.id}`}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="video-modal-youtube-link"
            className="inline-flex items-center gap-2 h-10 px-4 rounded-full bg-red-600 hover:bg-red-500 text-white text-[12.5px] font-bold transition shadow-lg shadow-red-900/40"
          >
            Voir sur YouTube <ExternalLink size={12} />
          </a>
        </div>
        {video.desc && (
          <div className="px-5 py-4 border-t border-white/5 text-white/65 text-[13.5px] leading-relaxed">{video.desc}</div>
        )}
      </div>
    </div>
  );
}

export default function TutosPage() {
  const [filter, setFilter] = useState('Toutes');
  const [playing, setPlaying] = useState(null);

  const matchesFilter = (v) => filter === 'Toutes' || v.cat === filter;
  const campagnes = CAMPAGNES.filter(matchesFilter);
  const tutos = TUTOS.filter(matchesFilter);

  return (
    <PageShell>
      <section className="max-w-7xl mx-auto px-4 lg:px-6 mt-8 sm:mt-12 mb-12 sm:mb-16" data-testid="tutos-page">
        <SectionTitle
          kicker="Vidéos · Sécurité routière"
          title="Apprends en regardant."
          sub="Campagnes officielles de la Sécurité routière. Lecteur intégré pour projection en salle · RDV pédagogiques · bilans · formations intermédiaires."
        />

        {/* Usage enseignant */}
        <div className="rounded-xl sm:rounded-2xl border border-red-700/30 bg-red-950/10 p-3.5 sm:p-4 lg:p-5 mb-6 sm:mb-8 flex items-start gap-3" data-testid="usage-pedago">
          <Sparkles size={16} className="text-red-400 shrink-0 mt-1" />
          <div className="text-white/80 text-[12.5px] sm:text-[13.5px] leading-relaxed">
            <span className="font-bold text-white">Comment utiliser ces vidéos en salle ?</span> Clique sur une vignette → le lecteur s&apos;ouvre en plein écran. Tu peux <span className="text-red-300 font-semibold">projeter directement depuis cette page</span> sans quitter codevoiture.fr.
          </div>
        </div>

        <div className="flex flex-wrap gap-1.5 sm:gap-2 mb-7 sm:mb-10">
          {CATS.map((c) => (
            <button
              key={c}
              onClick={() => setFilter(c)}
              data-testid={`tutos-filter-${c}`}
              className={`px-3 sm:px-4 h-8 sm:h-9 rounded-full text-[11.5px] sm:text-[12.5px] font-semibold border transition ${filter === c ? 'border-red-500 bg-red-600 text-white' : 'border-white/15 bg-white/5 text-white/70 hover:border-white/30 hover:text-white'}`}
            >
              {c}
            </button>
          ))}
        </div>

        {/* Campagnes officielles */}
        {campagnes.length > 0 && (
          <div className="mb-12">
            <div className="flex items-center gap-3 mb-5">
              <div className="px-3 py-1.5 rounded-full border border-red-700/40 bg-red-600/10 inline-flex items-center gap-2">
                <ShieldAlert size={13} className="text-red-400" />
                <span className="text-[10.5px] uppercase tracking-[0.22em] text-red-400 font-bold">Campagnes officielles Sécurité routière</span>
              </div>
              <span className="text-white/40 text-[12px] font-mono-spec">{campagnes.length} vidéo{campagnes.length > 1 ? 's' : ''}</span>
            </div>
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
              {campagnes.map((v) => (
                <VideoCard key={v.id} video={v} onPlay={setPlaying} official />
              ))}
            </div>
          </div>
        )}

        {campagnes.length === 0 && (
          <div className="text-white/50 py-10 text-center">Aucune vidéo pour ce filtre.</div>
        )}

        <div className="mt-12 text-center text-white/40 text-[12.5px] font-mono-spec">
          {CAMPAGNES.length} campagnes officielles · Lecture sur YouTube · Droits réservés aux auteurs
        </div>
      </section>

      <PlayerModal video={playing} onClose={() => setPlaying(null)} />
    </PageShell>
  );
}
